export function formatTimer(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export function calculateElapsedMinutes(startTime: Date): number {
  return Math.floor((Date.now() - startTime.getTime()) / 60000);
}
